import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";

// S2 endpoint — banner list
const BANNER_END_POINT = "event/admin/banners/";

/**
 * Hook to fetch banner images from S2 API.
 */
export function useBanner() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const { data: banners = [], isPending } = useQuery({
		queryKey: ["banners"],
		queryFn: async () => {
			const res = await callPymbleApi(instance, "GET", BANNER_END_POINT);
			return res ? [...res].reverse() : [];
		},
		enabled: isAuthenticated,
	});

	return {
		banners,
		bannersLoaded: !isPending,
	};
}
